import React from "react"
import { Card } from "@capioweb/ui-components"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import {
	XhtmlString,
	QBankImage,
	PropertyCategory,
} from "../../@types/CapioWeb/core"
import { createMarkup, imageBlockDataToImageProps } from "../../utils"
import { ColorKeys } from "@capioweb/ui-components/src"

export interface DiscoverCardProps {
	heading: StringProperty
	body: XhtmlString
	imageBlock: QBankImage
	tag?: PropertyCategory
	borderColor?: ColorKeys
}

export const DiscoverCard: React.FC<DiscoverCardProps> = (props) => {
	const [formattedBody, setFormattedBody] = React.useState(
		props.body.value ?? ""
	)

	React.useEffect(() => {
		const div = document.createElement("div")
		div.innerHTML = formattedBody
		const rteLinks = div.querySelectorAll("a")

		for (let i = 0; i < rteLinks.length; i++) {
			rteLinks[i].tabIndex = -1
		}

		setFormattedBody(div.innerHTML)
	}, [])

	const srcSetSizes = [{ width: 500, breakpoint: 2560 }]

	return (
		<Card
			w={33}
			h={55}
			media={
				<img
					data-epi-edit="imageBlock"
					{...imageBlockDataToImageProps(
						props.imageBlock,
						true,
						true,
						srcSetSizes
					)}
				/>
			}
			tag={props.tag.value.length > 0 && props.tag.value[0].description}
			borderColor={props.borderColor ?? "greyF3"}
		>
			<Card.Title>{props.heading.value}</Card.Title>
			{props.body.value && formattedBody && (
				<Card.Preamble>
					{<span dangerouslySetInnerHTML={createMarkup(formattedBody)}></span>}
				</Card.Preamble>
			)}
		</Card>
	)
}
